<template>
    <div class="pt-3 content-inputs" v-if="profile" v-loading="loading">
        <div class="row">
            <div class="form-group col-sm-6 col-md-4">
                <label for="profile_data_title" class="mb-1">Название анкеты</label>
                <input id="profile_data_title" type="text" class="form-control" v-model="profile.data.title" @focusout="changeField('title')">
            </div>
            <div class="form-group col-sm-12 col-md-8 d-flex justify-content-center align-items-end">
                <DocumentOcrModal class="text-center" @applied="onDocOCRRecognized" :currentFields="profile.data" />
            </div>
            <div class="form-group col-sm-6 col-md-4" >
                <div class="btn-group float-right" v-if="profiles_by_hash">
                    <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                        Копировать из другого салона
                    </button>
                    <div class="dropdown-menu">
                        <a v-for="(p,k) in profiles_by_hash" class="dropdown-item" @click="copy(p.data)">Копировать из {{p.platform_name}} {{p.name}}</a>
                    </div>
                </div>
            </div>
            <div class="col-12"></div>
            <div class="form-group col-sm-6 col-md-4">
                <label for="profile_data_car" class="mb-1">Автомобиль</label>
                <input id="profile_data_car" type="text" class="form-control" v-model="profile.data.car" @focusout="changeField('car')">
            </div>
            <div class="form-group col-sm-6 col-md-4">
                <label for="profile_data_car_year" class="mb-1">Год выпуска</label>
                <input id="profile_data_car_year" type="number" v-integer class="form-control" v-model="profile.data.car_year" @focusout="changeField('car_year')">
            </div>
            <div class="form-group col-sm-6 col-md-4">
                <label for="profile_data_car_cost" class="mb-1">Стоимость автомобиля</label>
                <input id="profile_data_car_cost" type="number" v-float class="form-control" v-model="profile.data.car_cost" @focusout="changeField('car_cost')">
            </div>
            <div class="form-group col-sm-6 col-md-4">
                <label for="profile_data_credit_term" class="mb-1">Срок кредита</label>
                <input id="profile_data_credit_term" type="text" class="form-control" v-model="profile.data.credit_term" @focusout="changeField('credit_term')">
            </div>
            <div class="form-group col-sm-6 col-md-4">
                <label for="profile_data_credit_initial_payment" class="mb-1">Первоначальный взнос</label>
                <input id="profile_data_credit_initial_payment" type="number" v-float class="form-control" v-model="profile.data.credit_initial_payment" @focusout="changeField('credit_initial_payment')">
            </div>
            <div class="form-group col-sm-6 col-md-4 d-flex align-items-center">
                <checkbox v-model="profile.data.kasko_in_credit" :id="'profile_data_kasko_in_credit'" :class="'custom-control-inline mb-2'" @change="changeField('kasko_in_credit')">КАСКО в кредит</checkbox>
            </div>

            <div class="col-12 mt-3"><h4>Персональные данные</h4></div>
            <div class="form-group col-sm-4 col-md-3">
                <label for="profile_data_last_name" class="mb-1">Фамилия</label>
                <input id="profile_data_last_name" type="text" class="form-control" v-model="profile.data.last_name" @focusout="changeField('last_name')">
            </div>
            <div class="form-group col-sm-4 col-md-3">
                <label for="profile_data_first_name" class="mb-1">Имя</label>
                <input id="profile_data_first_name" type="text" class="form-control" v-model="profile.data.first_name" @focusout="changeField('first_name')">
            </div>
            <div class="form-group col-sm-4 col-md-3">
                <label for="profile_data_middle_name" class="mb-1">Отчество</label>
                <input id="profile_data_middle_name" type="text" class="form-control" v-model="profile.data.middle_name" @focusout="changeField('middle_name')">
            </div>
            <div class="form-group col-sm-4 col-md-3 d-flex align-items-center">
                <checkbox v-model="profile.data.changed_lastname" :id="'profile_data_changed_lastname'" :class="'custom-control-inline'" @change="changeField('changed_lastname')">Была смена фамилии</checkbox>
            </div>
            <div class="form-group col-sm-4 col-md-3">
                <label for="profile_data_birthdate" class="mb-1">Дата рождения</label>
                <a v-if="profile.data.birthdate && profile.data.birthdate.length" class="copy-to-clipboard" @click="$copyDateToClipboard(profile.data.birthdate, 'DD.MM.YYYY')"><i class="far fa-clone"></i></a>
                <input id="profile_data_birthdate" type="date" class="form-control" v-model="profile.data.birthdate" @focusout="changeField('birthdate')">
            </div>
            <div class="form-group col-sm-12 col-md-4">
                <label for="profile_data_birthplace" class="mb-1">Место рождения</label>
                <input id="profile_data_birthplace" type="text" class="form-control" v-model="profile.data.birthplace" @focusout="changeField('birthplace')">
            </div>
            <div class="col-12 mb-3">
                <label class="mb-1">Фото клиента</label>
                <DocumentsUpload :filesModel.sync="profile.data.photo_client" :limit="5" @change="changeField('photo_client')" :disabled-remove="!$hasPermission('requests.profiles.edit')" :disabled-upload="!$hasPermission('requests.profiles.edit')"/>
            </div>

            <div class="col-12 mt-3"><h4>Паспортные данные</h4></div>
            <div class="form-group col-sm-4 col-md-3">
                <label for="profile_data_passport_series" class="mb-1">Серия</label>
                <input id="profile_data_passport_series" type="text" class="form-control" v-model="profile.data.passport_series" @focusout="changeField('passport_series')">
            </div>
            <div class="form-group col-sm-4 col-md-3">
                <label for="profile_data_passport_number" class="mb-1">Номер</label>
                <input id="profile_data_passport_number" type="text" class="form-control" v-model="profile.data.passport_number" @focusout="changeField('passport_number')">
            </div>
            <div class="form-group col-sm-4 col-md-3">
                <label for="profile_data_passport_division_code" class="mb-1">Код подразделения</label>
                <input id="profile_data_passport_division_code" type="text" class="form-control" v-model="profile.data.passport_division_code" @focusout="changeField('passport_division_code')">
            </div>
            <div class="form-group col-sm-4 col-md-3">
                <label for="profile_data_passport_issue_date" class="mb-1">Дата выдачи</label>
                <a v-if="profile.data.passport_issue_date && profile.data.passport_issue_date.length" class="copy-to-clipboard" @click="$copyDateToClipboard(profile.data.passport_issue_date, 'DD.MM.YYYY')"><i class="far fa-clone"></i></a>
                <input id="profile_data_passport_issue_date" type="date" class="form-control" v-model="profile.data.passport_issue_date" @focusout="changeField('passport_issue_date')">
            </div>
            <div class="form-group col-sm-12 col-md-8">
                <label for="profile_data_passport_issuing_authority" class="mb-1">Кем выдан</label>
                <input id="profile_data_passport_issuing_authority" type="text" class="form-control" v-model="profile.data.passport_issuing_authority" @focusout="changeField('passport_issuing_authority')">
            </div>
            <div class="form-group col-sm-12 col-md-4">
                <label for="profile_data_passport_old" class="mb-1">Ранее выданный паспорт</label>
                <input id="profile_data_passport_old" type="text" class="form-control" v-model="profile.data.passport_old" @focusout="changeField('passport_old')">
            </div>
            <div class="col-12 mb-3">
                <label class="mb-1">Скан паспорта</label>
                <DocumentsUpload :filesModel.sync="profile.data.passport_scans" :limit="20" @change="changeField('passport_scans')" :disabled-remove="!$hasPermission('requests.profiles.edit')" :disabled-upload="!$hasPermission('requests.profiles.edit')"/>
            </div>

            <div class="col-12 mt-3">
                <h4 class=" d-inline-block">Водительское</h4>
                <div class="custom-controls-stacked d-inline-block ml-2">
                    <label class="custom-control custom-radio custom-control-inline">
                        <input name="driving_license_isset" type="radio" class="custom-control-input" :value="true" v-model="profile.data.driving_license_isset" @change="changeField('driving_license_isset')">
                        <span class="custom-control-label">Есть</span>
                    </label>
                    <label class="custom-control custom-radio custom-control-inline">
                        <input name="driving_license_isset" type="radio" class="custom-control-input" :value="false" v-model="profile.data.driving_license_isset" @change="changeField('driving_license_isset')">
                        <span class="custom-control-label">Нет</span>
                    </label>
                </div>
            </div>
            <template v-if="profile.data.driving_license_isset">
                <div class="form-group col-sm-4 col-md-3">
                    <label for="profile_data_driving_license_series" class="mb-1">Серия</label>
                    <input id="profile_data_driving_license_series" type="text" class="form-control" v-model="profile.data.driving_license_series" @focusout="changeField('driving_license_series')">
                </div>
                <div class="form-group col-sm-4 col-md-3">
                    <label for="profile_data_driving_license_number" class="mb-1">Номер</label>
                    <input id="profile_data_driving_license_number" type="text" class="form-control" v-model="profile.data.driving_license_number" @focusout="changeField('driving_license_number')">
                </div>
                <div class="form-group col-sm-4 col-md-3">
                    <label for="profile_data_driving_license_division_code" class="mb-1">Дата выдачи</label>
                    <a v-if="profile.data.driving_license_division_code && profile.data.driving_license_division_code.length" class="copy-to-clipboard" @click="$copyDateToClipboard(profile.data.driving_license_division_code, 'DD.MM.YYYY')"><i class="far fa-clone"></i></a>
                    <input id="profile_data_driving_license_division_code" type="date" class="form-control" v-model="profile.data.driving_license_division_code" @focusout="changeField('driving_license_division_code')">
                </div>
                <div class="form-group col-sm-4 col-md-3">
                    <label for="profile_data_driving_license_experience" class="mb-1">Стаж</label>
                    <input id="profile_data_driving_license_experience" type="text" class="form-control" v-model="profile.data.driving_license_experience" @focusout="changeField('driving_license_experience')">
                </div>
                <div class="form-group col-sm-8 col-md-6">
                    <label for="profile_data_driving_license_issuing_authority" class="mb-1">Кем выдан</label>
                    <input id="profile_data_driving_license_issuing_authority" type="text" class="form-control" v-model="profile.data.driving_license_issuing_authority" @focusout="changeField('driving_license_issuing_authority')">
                </div>
                <div class="col-12 mb-3">
                    <label class="mb-1">Скан удостоверения</label>
                    <DocumentsUpload :filesModel.sync="profile.data.driving_license_scans" :limit="20" @change="changeField('driving_license_scans')" :disabled-remove="!$hasPermission('requests.profiles.edit')" :disabled-upload="!$hasPermission('requests.profiles.edit')"/>
                </div>
            </template>
            <template v-if="!profile.data.driving_license_isset">
                <div class="form-group col-sm-12 col-md-6 d-flex align-items-center">
                    <checkbox v-model="profile.data.ldu_isset" :id="'profile_data_ldu_isset'" :class="'custom-control-inline'" @change="changeField('ldu_isset')">Лицо допущенное к управлению</checkbox>
                </div>
            </template>

            <div class="col-12" v-if="!!(!profile.data.driving_license_isset && profile.data.ldu_isset)">
                <div class="row" style="background-color: #f1f6fd">
                    <div class="col-12 mt-3"><h3>Лицо допущенное к управлению</h3></div>
                    <div class="col-12 mt-3"><h4>Персональные данные</h4></div>
                    <div class="form-group col-sm-4 col-md-3">
                        <label for="profile_data_ldu_last_name" class="mb-1">Фамилия</label>
                        <input id="profile_data_ldu_last_name" type="text" class="form-control" v-model="profile.data.ldu_last_name" @focusout="changeField('ldu_last_name')">
                    </div>
                    <div class="form-group col-sm-4 col-md-3">
                        <label for="profile_data_ldu_first_name" class="mb-1">Имя</label>
                        <input id="profile_data_ldu_first_name" type="text" class="form-control" v-model="profile.data.ldu_first_name" @focusout="changeField('ldu_first_name')">
                    </div>
                    <div class="form-group col-sm-4 col-md-3">
                        <label for="profile_data_ldu_middle_name" class="mb-1">Отчество</label>
                        <input id="profile_data_ldu_middle_name" type="text" class="form-control" v-model="profile.data.ldu_middle_name" @focusout="changeField('ldu_middle_name')">
                    </div>
                    <div class="form-group col-sm-4 col-md-3">
                        <label for="profile_data_ldu_type_relationship" class="mb-1">Кем приходится</label>
                        <input id="profile_data_ldu_type_relationship" type="text" class="form-control" v-model="profile.data.ldu_type_relationship" @focusout="changeField('ldu_type_relationship')">
                    </div>
                    <div class="form-group col-sm-4 col-md-3">
                        <label for="profile_data_ldu_birthdate" class="mb-1">Дата рождения</label>
                        <a v-if="profile.data.ldu_birthdate && profile.data.ldu_birthdate.length" class="copy-to-clipboard" @click="$copyDateToClipboard(profile.data.ldu_birthdate, 'DD.MM.YYYY')"><i class="far fa-clone"></i></a>
                        <input id="profile_data_ldu_birthdate" type="date" class="form-control" v-model="profile.data.ldu_birthdate" @focusout="changeField('ldu_birthdate')">
                    </div>
                    <div class="form-group col-sm-12 col-md-6">
                        <label for="profile_data_ldu_birthplace" class="mb-1">Место рождения</label>
                        <input id="profile_data_ldu_birthplace" type="text" class="form-control" v-model="profile.data.ldu_birthplace" @focusout="changeField('ldu_birthplace')">
                    </div>
                    <div class="form-group col-sm-4 col-md-3">
                        <label for="profile_data_ldu_phone" class="mb-1">Телефон</label>
                        <a v-if="profile.data.ldu_phone && preparePhone(profile.data.ldu_phone)" class="copy-to-clipboard" @click="$copyToClipboard(preparePhone(profile.data.ldu_phone).slice(2))"><i class="far fa-clone"></i></a>
                        <input id="profile_data_ldu_phone" type="tel" class="form-control" v-mask="{mask: '+7 (999) 999-99-99', clearIncomplete: true}" v-model="profile.data.ldu_phone" @focusout="onRemovedPhone('ldu_phone')">
                    </div>

                    <div class="col-12 mt-3"><h4>Паспортные данные</h4></div>
                    <div class="form-group col-sm-4 col-md-3">
                        <label for="profile_data_ldu_passport_series" class="mb-1">Серия</label>
                        <input id="profile_data_ldu_passport_series" type="text" class="form-control" v-model="profile.data.ldu_passport_series" @focusout="changeField('ldu_passport_series')">
                    </div>
                    <div class="form-group col-sm-4 col-md-3">
                        <label for="profile_data_ldu_passport_number" class="mb-1">Номер</label>
                        <input id="profile_data_ldu_passport_number" type="text" class="form-control" v-model="profile.data.ldu_passport_number" @focusout="changeField('ldu_passport_number')">
                    </div>
                    <div class="form-group col-sm-4 col-md-3">
                        <label for="profile_data_ldu_passport_division_code" class="mb-1">Код подразделения</label>
                        <input id="profile_data_ldu_passport_division_code" type="text" class="form-control" v-model="profile.data.ldu_passport_division_code" @focusout="changeField('ldu_passport_division_code')">
                    </div>
                    <div class="form-group col-sm-4 col-md-3">
                        <label for="profile_data_ldu_passport_issue_date" class="mb-1">Дата выдачи</label>
                        <a v-if="profile.data.ldu_passport_issue_date && profile.data.ldu_passport_issue_date.length" class="copy-to-clipboard" @click="$copyDateToClipboard(profile.data.ldu_passport_issue_date, 'DD.MM.YYYY')"><i class="far fa-clone"></i></a>
                        <input id="profile_data_ldu_passport_issue_date" type="date" class="form-control" v-model="profile.data.ldu_passport_issue_date" @focusout="changeField('ldu_passport_issue_date')">
                    </div>
                    <div class="form-group col-sm-12 col-md-8">
                        <label for="profile_data_ldu_passport_issuing_authority" class="mb-1">Кем выдан</label>
                        <input id="profile_data_ldu_passport_issuing_authority" type="text" class="form-control" v-model="profile.data.ldu_passport_issuing_authority" @focusout="changeField('ldu_passport_issuing_authority')">
                    </div>
                    <div class="col-12 mb-3">
                        <label class="mb-1">Скан паспорта</label>
                        <DocumentsUpload :filesModel.sync="profile.data.ldu_passport_scans" :limit="20" @change="changeField('ldu_passport_scans')" :disabled-remove="!$hasPermission('requests.profiles.edit')" :disabled-upload="!$hasPermission('requests.profiles.edit')"/>
                    </div>

                    <div class="col-12 mt-3"><h4>Водительское удостоверение</h4></div>
                    <div class="form-group col-sm-4 col-md-3">
                        <label for="profile_data_ldu_driving_license_series" class="mb-1">Серия</label>
                        <input id="profile_data_ldu_driving_license_series" type="text" class="form-control" v-model="profile.data.ldu_driving_license_series" @focusout="changeField('ldu_driving_license_series')">
                    </div>
                    <div class="form-group col-sm-4 col-md-3">
                        <label for="profile_data_ldu_driving_license_number" class="mb-1">Номер</label>
                        <input id="profile_data_ldu_driving_license_number" type="text" class="form-control" v-model="profile.data.ldu_driving_license_number" @focusout="changeField('ldu_driving_license_number')">
                    </div>
                    <div class="form-group col-sm-4 col-md-3">
                        <label for="profile_data_ldu_driving_license_division_code" class="mb-1">Дата выдачи</label>
                        <a v-if="profile.data.ldu_driving_license_division_code && profile.data.ldu_driving_license_division_code.length" class="copy-to-clipboard" @click="$copyDateToClipboard(profile.data.ldu_driving_license_division_code, 'DD.MM.YYYY')"><i class="far fa-clone"></i></a>
                        <input id="profile_data_ldu_driving_license_division_code" type="date" class="form-control" v-model="profile.data.ldu_driving_license_division_code" @focusout="changeField('ldu_driving_license_division_code')">
                    </div>
                    <div class="form-group col-sm-4 col-md-3">
                        <label for="profile_data_ldu_driving_license_experience" class="mb-1">Стаж</label>
                        <input id="profile_data_ldu_driving_license_experience" type="text" class="form-control" v-model="profile.data.ldu_driving_license_experience" @focusout="changeField('ldu_driving_license_experience')">
                    </div>
                    <div class="form-group col-sm-8 col-md-6">
                        <label for="profile_data_ldu_driving_license_issuing_authority" class="mb-1">Кем выдан</label>
                        <input id="profile_data_ldu_driving_license_issuing_authority" type="text" class="form-control" v-model="profile.data.ldu_driving_license_issuing_authority" @focusout="changeField('ldu_driving_license_issuing_authority')">
                    </div>
                    <div class="col-12 mb-3">
                        <label class="mb-1">Скан удостоверения</label>
                        <DocumentsUpload :filesModel.sync="profile.data.ldu_driving_license_scans" :limit="15" @change="changeField('ldu_driving_license_scans')" :disabled-remove="!$hasPermission('requests.profiles.edit')" :disabled-upload="!$hasPermission('requests.profiles.edit')"/>
                    </div>

                    <div class="col-12 mt-3"><h4>Адрес</h4></div>
                    <div class="form-group col-sm-12 col-md-9">
                        <label for="profile_data_ldu_registration_address" class="mb-1">Адрес прописки</label>
                        <input id="profile_data_ldu_registration_address" type="text" class="form-control" v-model="profile.data.ldu_registration_address" @focusout="changeField('ldu_registration_address')">
                    </div>
                    <div class="form-group col-sm-4 col-md-3">
                        <label for="profile_data_ldu_registration_date" class="mb-1">Дата регистрации</label>
                        <a v-if="profile.data.ldu_registration_date && profile.data.ldu_registration_date.length" class="copy-to-clipboard" @click="$copyDateToClipboard(profile.data.ldu_registration_date, 'DD.MM.YYYY')"><i class="far fa-clone"></i></a>
                        <input id="profile_data_ldu_registration_date" type="date" class="form-control" v-model="profile.data.ldu_registration_date" @focusout="changeField('ldu_registration_date')">
                    </div>
                </div>
            </div>

            <div class="col-12 mt-3"><h4>Адрес</h4></div>
            <div class="form-group col-12">
                <label for="profile_data_registration_address" class="mb-1">Адрес прописки</label>
                <input id="profile_data_registration_address" type="text" class="form-control" v-model="profile.data.registration_address" @change="changeAddress()" @focusout="changeField(['registration_address', 'residence_address'])">
            </div>
            <div class="form-group col-sm-4 col-md-3 d-flex align-items-center">
                <checkbox v-model="profile.data.registration_address_ownership" :id="'profile_data_registration_address_ownership'" :class="'custom-control-inline'" @change="changeAddress() || changeField(['registration_address_ownership', 'residence_ownership'])">В собственности</checkbox>
            </div>
            <div class="form-group col-sm-4 col-md-3">
                <label for="profile_data_registration_date" class="mb-1">Дата регистрации</label>
                <a v-if="profile.data.registration_date && profile.data.registration_date.length" class="copy-to-clipboard" @click="$copyDateToClipboard(profile.data.registration_date, 'DD.MM.YYYY')"><i class="far fa-clone"></i></a>
                <input id="profile_data_registration_date" type="date" class="form-control" v-model="profile.data.registration_date" @focusout="changeField('registration_date')">
            </div>
            <div class="form-group col-sm-4 col-md-3">
                <label for="profile_data_registration_phone" class="mb-1">Дом. телефон</label>
                <a v-if="profile.data.registration_phone && preparePhone(profile.data.registration_phone)" class="copy-to-clipboard" @click="$copyToClipboard(preparePhone(profile.data.registration_phone).slice(2))"><i class="far fa-clone"></i></a>
                <input id="profile_data_registration_phone" type="tel" class="form-control" v-mask="{mask: '+7 (999) 999-99-99', clearIncomplete: true}" v-model="profile.data.registration_phone" @focusout="onRemovedPhone('registration_phone')">
            </div>
            <div class="form-group col-12">
                <label for="profile_data_residence_address" class="mb-1">Адрес фактического проживания</label>
                <checkbox v-model="profile.data.registration_and_residence_address_match" :id="'profile_data_registration_and_residence_address_match'" :class="'custom-control-inline ml-2'" @click="copyAddress() || changeField(['registration_and_residence_address_match', 'registration_address', 'residence_address', 'registration_address_ownership', 'residence_ownership'])">Совпадает</checkbox>
                <input v-if="!profile.data.registration_and_residence_address_match" id="profile_data_residence_address" type="text" class="form-control" :disabled="profile.data.registration_and_residence_address_match" v-model="profile.data.residence_address" @focusout="changeField('residence_address')">
            </div>
            <div class="form-group col-sm-4 col-md-3 d-flex align-items-center" v-if="!profile.data.registration_and_residence_address_match">
                <checkbox :disabled="profile.data.registration_and_residence_address_match" v-model="profile.data.residence_ownership" :id="'profile_data_residence_ownership'" :class="'custom-control-inline'" @change="changeField(['registration_address_ownership', 'residence_ownership'])">В собственности</checkbox>
            </div>
            <div class="form-group col-sm-4 col-md-3">
                <label for="profile_data_residence_period" class="mb-1">Срок проживания</label>
                <input id="profile_data_residence_period" type="text" class="form-control" v-model="profile.data.residence_period" @focusout="changeField('residence_period')">
            </div>
            <div class="form-group col-sm-4 col-md-3">
                <label for="profile_data_residence_phone" class="mb-1">Моб. телефон</label>
                <a v-if="profile.data.residence_phone && preparePhone(profile.data.residence_phone)" class="copy-to-clipboard" @click="$copyToClipboard(preparePhone(profile.data.residence_phone).slice(2))"><i class="far fa-clone"></i></a>
                <input id="profile_data_residence_phone" type="tel" class="form-control" v-mask="{mask: '+7 (999) 999-99-99', clearIncomplete: true}" v-model="profile.data.residence_phone" @focusout="onRemovedPhone('residence_phone')">
            </div>

            <div class="col-12 mt-3"><h4>Другие документы</h4></div>
            <div class="form-group col-sm-6 col-md-4">
                <label for="profile_data_snils" class="mb-1">Страх. свидетельство</label>
                <input id="profile_data_snils" type="text" class="form-control" v-model="profile.data.snils" @focusout="changeField('snils')">
            </div>
            <div class="form-group col-sm-6 col-md-4">
                <label for="profile_data_international_passport" class="mb-1">Загран. паспорт (серия, номер)</label>
                <input id="profile_data_international_passport" type="text" class="form-control" v-model="profile.data.international_passport" @focusout="changeField('international_passport')">
            </div>
            <div class="form-group col-sm-6 col-md-4">
                <label for="profile_data_military_id" class="mb-1">Военный билет или удостов.</label>
                <input id="profile_data_military_id" type="text" class="form-control" v-model="profile.data.military_id" @focusout="changeField('military_id')">
            </div>

            <div class="form-group col-sm-6 col-md-4">
                <label for="profile_data_inn" class="mb-1">ИНН</label>
                <input id="profile_data_inn" type="text" class="form-control" v-model="profile.data.inn" @focusout="changeField('inn')">
            </div>
            <div class="col-12 mb-3">
                <DocumentsUpload :filesModel.sync="profile.data.other_documents_scans" :limit="50" @change="changeField('other_documents_scans')" :disabled-remove="!$hasPermission('requests.profiles.edit')" :disabled-upload="!$hasPermission('requests.profiles.edit')"/>
            </div>

            <div class="col-12 mt-3"><h4>Образование</h4></div>
            <div class="form-group col-12">
                <div class="custom-controls-stacked">
                    <label class="custom-control custom-radio custom-control-inline">
                        <input name="education" type="radio" class="custom-control-input" value="higher" v-model="profile.data.education" @change="changeField('education')">
                        <span class="custom-control-label">Высшее</span>
                    </label>
                    <label class="custom-control custom-radio custom-control-inline">
                        <input name="education" type="radio" class="custom-control-input" value="secondary" v-model="profile.data.education" @change="changeField('education')">
                        <span class="custom-control-label">Средне-специальное</span>
                    </label>
                </div>
            </div>
            <div class="col-12 mt-3">
                <h4 class="d-inline-block">Место работы</h4>
                <div class="custom-controls-stacked d-inline-block ml-2">
                    <label class="custom-control custom-radio custom-control-inline">
                        <input name="job_isset" type="radio" class="custom-control-input" :value="true" v-model="profile.data.job_isset" @change="changeField('job_isset')">
                        <span class="custom-control-label">Есть</span>
                    </label>
                    <label class="custom-control custom-radio custom-control-inline">
                        <input name="job_isset" type="radio" class="custom-control-input" :value="false" v-model="profile.data.job_isset" @change="changeField('job_isset')">
                        <span class="custom-control-label">Нет</span>
                    </label>
                </div>
            </div>
            <div v-if="profile.data.job_isset" class="form-group col-sm-6 col-md-3">
                <label for="profile_data_job_organization_name" class="mb-1">Название организации</label>
                <input id="profile_data_job_organization_name" type="text" class="form-control" v-model="profile.data.job_organization_name" @focusout="changeField('job_organization_name')">
            </div>
            <div v-if="profile.data.job_isset" class="form-group col-sm-6 col-md-3">
                <label for="profile_data_job_organization_inn" class="mb-1">ИНН</label>
                <input id="profile_data_job_organization_inn" type="text" class="form-control" v-model="profile.data.job_organization_inn" @focusout="changeField('job_organization_inn')">
            </div>
            <div v-if="profile.data.job_isset" class="form-group col-sm-6 col-md-3">
                <label for="profile_data_job_organization_phone" class="mb-1">Телефон</label>
                <a v-if="profile.data.job_organization_phone && preparePhone(profile.data.job_organization_phone)" class="copy-to-clipboard" @click="$copyToClipboard(preparePhone(profile.data.job_organization_phone).slice(2))"><i class="far fa-clone"></i></a>
                <input id="profile_data_job_organization_phone" type="tel" class="form-control" v-mask="{mask: '+7 (999) 999-99-99', clearIncomplete: true}" v-model="profile.data.job_organization_phone" @focusout="onRemovedPhone('job_organization_phone')">
            </div>
            <div v-if="profile.data.job_isset" class="form-group col-12">
                <label for="profile_data_job_organization_address_legal" class="mb-1">Адрес юридический</label>
                <input id="profile_data_job_organization_address_legal" type="text" class="form-control" v-model="profile.data.job_organization_address_legal" @focusout="changeField('job_organization_address_legal')">
            </div>
            <div v-if="profile.data.job_isset" class="form-group col-12">
                <label for="profile_data_job_organization_address_real" class="mb-1">Адрес фактический</label>
                <input id="profile_data_job_organization_address_real" type="text" class="form-control" v-model="profile.data.job_organization_address_real" @focusout="changeField('job_organization_address_real')">
            </div>
            <div v-if="profile.data.job_isset" class="form-group col-sm-6 col-md-4">
                <label for="profile_data_job_organization_business_field" class="mb-1">Сфера деятельности</label>
                <input id="profile_data_job_organization_business_field" type="text" class="form-control" v-model="profile.data.job_organization_business_field" @focusout="changeField('job_organization_business_field')">
            </div>
            <div v-if="profile.data.job_isset" class="form-group col-sm-6 col-md-4">
                <label for="profile_data_job_position" class="mb-1">Должность</label>
                <input id="profile_data_job_position" type="text" class="form-control" v-model="profile.data.job_position" @focusout="changeField('job_position')">
            </div>
            <div v-if="profile.data.job_isset" class="form-group col-sm-6 col-md-4">
                <label for="profile_data_job_experience" class="mb-1">Стаж работы</label>
                <input id="profile_data_job_experience" type="text" class="form-control" v-model="profile.data.job_experience" @focusout="changeField('job_experience')">
            </div>
            <div class="form-group col-sm-6 col-md-4">
                <label for="profile_data_job_general_experience" class="mb-1">Общий труд. стаж</label>
                <input id="profile_data_job_general_experience" type="text" class="form-control" v-model="profile.data.job_general_experience" @focusout="changeField('job_general_experience')">
            </div>
            <div v-if="profile.data.job_isset" class="form-group col-sm-6 col-md-4">
                <label for="profile_data_job_boss_fullname" class="mb-1">ФИО руководителя</label>
                <input id="profile_data_job_boss_fullname" type="text" class="form-control" v-model="profile.data.job_boss_fullname" @focusout="changeField('job_boss_fullname')">
            </div>
            <div v-if="profile.data.job_isset" class="form-group col-sm-6 col-md-4">
                <label for="profile_data_job_boss_phone" class="mb-1">Телефон руководителя</label>
                <a v-if="profile.data.job_boss_phone && preparePhone(profile.data.job_boss_phone)" class="copy-to-clipboard" @click="$copyToClipboard(preparePhone(profile.data.job_boss_phone).slice(2))"><i class="far fa-clone"></i></a>
                <input id="profile_data_job_boss_phone" type="tel" class="form-control" v-mask="{mask: '+7 (999) 999-99-99', clearIncomplete: true}" v-model="profile.data.job_boss_phone" @focusout="onRemovedPhone('job_boss_phone')">
            </div>

            <div class="col-12 mt-3"><h4>Доходы</h4></div>
            <div class="col-12 mt-2">
                <div class="row border-bottom">
                    <div class="col-12"><h5>Клиент</h5></div>
                    <div class="form-group col-6 col-sm-3">
                        <label for="profile_data_income_monthly_average" class="mb-1">Среднемесячный</label>
                        <input id="profile_data_income_monthly_average" type="number" v-float class="form-control" v-model="profile.data.income_monthly_average" @focusout="changeField('income_monthly_average')">
                    </div>
                    <div class="form-group col-6 col-sm-3">
                        <label for="profile_data_income_additional" class="mb-1">Дополнительный</label>
                        <input id="profile_data_income_additional" type="number" v-float class="form-control" v-model="profile.data.income_additional" @focusout="changeField('income_additional')">
                    </div>
                    <div class="form-group col-sm-6">
                        <label for="profile_data_income_additional_comment" class="mb-1">Комментарий</label>
                        <input id="profile_data_income_additional_comment" type="text" class="form-control" v-model="profile.data.income_additional_comment" @focusout="changeField('income_additional_comment')">
                    </div>
                </div>
            </div>
            <div class="col-12 mt-2" v-if="profile.data.family_status === 'married' || profile.data.family_status === 'civil_marriage'">
                <div class="row border-bottom">
                    <div class="col-12"><h5>Супруг</h5></div>
                    <div class="form-group col-6 col-sm-3">
                        <label for="profile_data_spouse_income_monthly_average" class="mb-1">Среднемесячный</label>
                        <input id="profile_data_spouse_income_monthly_average" type="number" v-float class="form-control" v-model="profile.data.spouse_income_monthly_average" @focusout="changeField('spouse_income_monthly_average')">
                    </div>
                    <div class="form-group col-6 col-sm-3">
                        <label for="profile_data_spouse_income_additional" class="mb-1">Дополнительный</label>
                        <input id="profile_data_spouse_income_additional" type="number" v-float class="form-control" v-model="profile.data.spouse_income_additional" @focusout="changeField('spouse_income_additional')">
                    </div>
                    <div class="form-group col-sm-6">
                        <label for="profile_data_spouse_income_additional_comment" class="mb-1">Комментарий</label>
                        <input id="profile_data_spouse_income_additional_comment" type="text" class="form-control" v-model="profile.data.spouse_income_additional_comment" @focusout="changeField('spouse_income_additional_comment')">
                    </div>
                </div>
            </div>
            <div class="col-12 mt-2">
                <div class="row">
                    <div class="col-12"><h5>Семейный</h5></div>
                    <div class="form-group col-6 col-sm-3">
                        <label for="profile_data_family_income_monthly_average" class="mb-1">Среднемесячный</label>
                        <input id="profile_data_family_income_monthly_average" type="number" v-float class="form-control" v-model="profile.data.family_income_monthly_average" @focusout="changeField('family_income_monthly_average')">
                    </div>
                    <div class="form-group col-6 col-sm-3">
                        <label for="profile_data_family_income_additional" class="mb-1">Дополнительный</label>
                        <input id="profile_data_family_income_additional" type="number" v-float class="form-control" v-model="profile.data.family_income_additional" @focusout="changeField('family_income_additional')">
                    </div>
                    <div class="form-group col-sm-6">
                        <label for="profile_data_family_income_additional_comment" class="mb-1">Комментарий</label>
                        <input id="profile_data_family_income_additional_comment" type="text" class="form-control" v-model="profile.data.family_income_additional_comment" @focusout="changeField('family_income_additional_comment')">
                    </div>
                </div>
            </div>

            <div class="col-12 mt-3"><h4>Семейное положение</h4></div>
            <div class="form-group col-12">
                <div class="custom-controls-stacked">
                    <label class="custom-control custom-radio custom-control-inline">
                        <input name="family_status" type="radio" class="custom-control-input" value="married" v-model="profile.data.family_status" @change="changeField('family_status')">
                        <span class="custom-control-label">В браке</span>
                    </label>
                    <label class="custom-control custom-radio custom-control-inline">
                        <input name="family_status" type="radio" class="custom-control-input" value="civil_marriage" v-model="profile.data.family_status" @change="changeField('family_status')">
                        <span class="custom-control-label">В гражданском браке</span>
                    </label>
                    <label class="custom-control custom-radio custom-control-inline">
                        <input name="family_status" type="radio" class="custom-control-input" value="divorced" v-model="profile.data.family_status" @change="changeField('family_status')">
                        <span class="custom-control-label">Разведен</span>
                    </label>
                    <label class="custom-control custom-radio custom-control-inline">
                        <input name="family_status" type="radio" class="custom-control-input" value="single" v-model="profile.data.family_status" @change="changeField('family_status')">
                        <span class="custom-control-label">Холост</span>
                    </label>
                </div>
            </div>

            <template v-if="profile.data.family_status === 'married' || profile.data.family_status === 'civil_marriage'">
                <div class="col-12 mt-3"><h4>Информация о супруге</h4></div>
                <div class="form-group col-sm-4">
                    <label for="profile_data_spouse_last_name" class="mb-1">Фамилия</label>
                    <input id="profile_data_spouse_last_name" type="text" class="form-control" v-model="profile.data.spouse_last_name" @focusout="changeField('spouse_last_name')">
                </div>
                <div class="form-group col-sm-4">
                    <label for="profile_data_spouse_first_name" class="mb-1">Имя</label>
                    <input id="profile_data_spouse_first_name" type="text" class="form-control" v-model="profile.data.spouse_first_name" @focusout="changeField('spouse_first_name')">
                </div>
                <div class="form-group col-sm-4">
                    <label for="profile_data_spouse_middle_name" class="mb-1">Отчество</label>
                    <input id="profile_data_spouse_middle_name" type="text" class="form-control" v-model="profile.data.spouse_middle_name" @focusout="changeField('spouse_middle_name')">
                </div>
                <div class="form-group col-sm-8 col-md-6">
                    <label for="profile_data_spouse_birthplace" class="mb-1">Место рождения</label>
                    <input id="profile_data_spouse_birthplace" type="text" class="form-control" v-model="profile.data.spouse_birthplace" @focusout="changeField('spouse_birthplace')">
                </div>
                <div class="form-group col-sm-4 col-md-3">
                    <label for="profile_data_spouse_birthdate" class="mb-1">Дата рождения</label>
                    <a v-if="profile.data.spouse_birthdate && profile.data.spouse_birthdate.length" class="copy-to-clipboard" @click="$copyDateToClipboard(profile.data.spouse_birthdate, 'DD.MM.YYYY')"><i class="far fa-clone"></i></a>
                    <input id="profile_data_spouse_birthdate" type="date" class="form-control" v-model="profile.data.spouse_birthdate" @focusout="changeField('spouse_birthdate')">
                </div>
                <div class="form-group col-sm-4 col-md-3">
                    <label for="profile_data_spouse_phone" class="mb-1">Телефон</label>
                    <a v-if="profile.data.spouse_phone && preparePhone(profile.data.spouse_phone)" class="copy-to-clipboard" @click="$copyToClipboard(preparePhone(profile.data.spouse_phone).slice(2))"><i class="far fa-clone"></i></a>
                    <input id="profile_data_spouse_phone" type="tel" class="form-control" v-mask="{mask: '+7 (999) 999-99-99', clearIncomplete: true}" v-model="profile.data.spouse_phone" @focusout="onRemovedPhone('spouse_phone')">
                </div>
                <div class="form-group col-sm-4 col-md-3">
                    <label for="profile_data_spouse_job_organization_name" class="mb-1">Название организации</label>
                    <input id="profile_data_spouse_job_organization_name" type="text" class="form-control" v-model="profile.data.spouse_job_organization_name" @focusout="changeField('spouse_job_organization_name')">
                </div>
                <div class="form-group col-sm-4 col-md-3">
                    <label for="profile_data_spouse_job_position" class="mb-1">Должность</label>
                    <input id="profile_data_spouse_job_position" type="text" class="form-control" v-model="profile.data.spouse_job_position" @focusout="changeField('spouse_job_position')">
                </div>
<!--                <div class="form-group col-3">-->
<!--                    <label for="profile_data_spouse_income" class="mb-1">Доход</label>-->
<!--                    <input id="profile_data_spouse_income" type="number" class="form-control" v-model="profile.data.spouse_income" @focusout="incrementChanged">-->
<!--                </div>-->
<!--                <div class="form-group col-3">-->
<!--                    <label for="profile_data_spouse_income_additional" class="mb-1">Доп. доход</label>-->
<!--                    <input id="profile_data_spouse_income_additional" type="number" class="form-control" v-model="profile.data.spouse_income_additional" @focusout="incrementChanged">-->
<!--                </div>-->
            </template>

            <div class="col-12 mt-3"><h4>Информация о детях</h4></div>
            <div class="form-group col-sm-6 col-md-3">
                <label for="profile_data_children_count" class="mb-1">Кол-во детей</label>
                <input id="profile_data_children_count" type="number" v-integer class="form-control" v-model="profile.data.children_count" @focusout="changeField('children_count')">
            </div>
            <div class="form-group col-sm-6 col-md-3">
                <label for="profile_data_children_dependent_count" class="mb-1">На иждивении</label>
                <input id="profile_data_children_dependent_count" type="number" v-integer class="form-control" v-model="profile.data.children_dependent_count" @focusout="changeField('children_dependent_count')">
            </div>

            <div class="col-12 mt-3"><h4>Информация о кредитах</h4></div>
            <div class="form-group col-sm-4 d-flex align-items-center">
                <checkbox v-model="profile.data.were_loans" :id="'profile_data_were_loans'" :class="'custom-control-inline'" @change="changeField('were_loans')">Ранее получали кредиты</checkbox>
            </div>
            <div class="form-group col-sm-8" v-if="profile.data.were_loans">
                <label for="profile_data_were_loans_comment" class="mb-1">Комментарий</label>
                <input id="profile_data_were_loans_comment" type="text" class="form-control" v-model="profile.data.were_loans_comment" @focusout="changeField('were_loans_comment')">
            </div>

            <div class="col-12 mt-3">
                <h4 class="d-inline-block">Действующие кредиты</h4>
                <div class="custom-controls-stacked d-inline-block ml-2">
                    <label class="custom-control custom-radio custom-control-inline">
                        <input name="current_loans_isset" type="radio" class="custom-control-input" :value="true" v-model="profile.data.current_loans_isset" @change="changeField('current_loans_isset')">
                        <span class="custom-control-label">Есть</span>
                    </label>
                    <label class="custom-control custom-radio custom-control-inline">
                        <input name="current_loans_isset" type="radio" class="custom-control-input" :value="false" v-model="profile.data.current_loans_isset" @change="changeField('current_loans_isset')">
                        <span class="custom-control-label">Нет</span>
                    </label>
                </div>
            </div>
            <template v-if="profile.data.current_loans_isset">
                <div class="form-group col-sm-6">
                    <label for="profile_data_current_loans_bank_name" class="mb-1">Банк</label>
                    <input id="profile_data_current_loans_bank_name" type="text" class="form-control" v-model="profile.data.current_loans_bank_name" @focusout="changeField('current_loans_bank_name')">
                </div>
                <div class="form-group col-sm-6">
                    <label for="profile_data_current_loans_target" class="mb-1">Цель кредита</label>
                    <input id="profile_data_current_loans_target" type="text" class="form-control" v-model="profile.data.current_loans_target" @focusout="changeField('current_loans_target')">
                </div>
                <div class="form-group col-sm-4">
                    <label for="profile_data_current_loans_total_amount" class="mb-1">Общая сумма</label>
                    <input id="profile_data_current_loans_total_amount" type="number" v-float class="form-control" v-model="profile.data.current_loans_total_amount" @focusout="changeField('current_loans_total_amount')">
                </div>
                <div class="form-group col-sm-4">
                    <label for="profile_data_current_loans_monthly_payment" class="mb-1">Ежемесячный платеж</label>
                    <input id="profile_data_current_loans_monthly_payment" type="number" v-float class="form-control" v-model="profile.data.current_loans_monthly_payment" @focusout="changeField('current_loans_monthly_payment')">
                </div>
                <div class="form-group col-sm-4">
                    <label for="profile_data_current_loans_remaining_debt" class="mb-1">Остаток</label>
                    <input id="profile_data_current_loans_remaining_debt" type="number" v-float class="form-control" v-model="profile.data.current_loans_remaining_debt" @focusout="changeField('current_loans_remaining_debt')">
                </div>
            </template>

            <div class="col-12 mt-3">
                <h4 class="d-inline-block">Контактные лица</h4>
                <button @click="addContactPerson()" class="btn btn-link ml-2">Добавить</button>
            </div>
            <template v-if="profile.data.contact_persons" v-for="contact_person in profile.data.contact_persons">
                <div class="form-group col-sm-6 col-md-3 px-3 pr-sm-1">
                    <label class="mb-1">Кем приходится</label>
                    <input type="text" class="form-control" v-model="contact_person.type_relationship" @focusout="changeField('contact_persons')">
                </div>
                <div class="form-group col-sm-6 col-md-3 px-3 pl-sm-0 pl-sm-1 px-md-1">
                    <label class="mb-1">ФИО</label>
                    <input type="text" class="form-control" v-model="contact_person.fio" @focusout="changeField('contact_persons')">
                </div>
                <div class="form-group col-sm-5 col-md-2 px-3 pr-sm-1 pl-md-1">
                    <label class="mb-1">Дата рождения</label>
                    <a v-if="contact_person.birthdate && contact_person.birthdate.length" class="copy-to-clipboard" @click="$copyDateToClipboard(contact_person.birthdate, 'DD.MM.YYYY')"><i class="far fa-clone"></i></a>
                    <input type="date" class="form-control" v-model="contact_person.birthdate" @focusout="changeField('contact_persons')">
                </div>
                <div class="form-group col-sm-6 col-md-3 px-3 px-sm-1 px-md-1">
                    <label class="mb-1">Телефон</label>
                    <a v-if="contact_person.phone && preparePhone(contact_person.phone)" class="copy-to-clipboard" @click="$copyToClipboard(preparePhone(contact_person.phone).slice(2))"><i class="far fa-clone"></i></a>
                    <input type="tel" class="form-control" v-mask="{mask: '+7 (999) 999-99-99', clearIncomplete: true}" v-model="contact_person.phone" @focusout="changeField('contact_persons')">
                </div>
                <div class="col-1 pl-1 d-flex align-items-center">
                    <button class="btn btn-link" @click="deleteContactPerson(contact_person.id)"><i class="fas fa-times"></i></button>
                </div>
            </template>

            <div class="col-12 mt-3"><h4>Соглашения</h4></div>
            <div class="col-12 mb-3">
                <DocumentsUpload :filesModel.sync="profile.data.agreements_scans" :limit="50" @change="changeField('agreements_scans')" :disabled-remove="!$hasPermission('requests.profiles.edit')" :disabled-upload="!$hasPermission('requests.profiles.edit')"/>
            </div>

<!--            <div class="col-12">-->
<!--                <button class="btn btn-lg btn-primary" @click="clickSave" v-if="$hasPermission('requests.profiles.edit')">Сохранить</button>-->
<!--            </div>-->
        </div>
    </div>
</template>

<script>
    import Checkbox from "../../Checkbox";
    import DocumentsUpload from "./DocumentsUpload";
    import Swal from 'sweetalert2';
    import DocumentOcrModal from "./DocumentOcrModal.vue";

    export default {
        name: "Profile",
        components: {DocumentOcrModal, DocumentsUpload, Checkbox},
        props: ['profile_model'],
        data: () => ({
            profile: null,
            saved_profile: null,
            changed_count: 0,
            auto_save_interval: null,
            last_saved_profile_stringify: "",
            loading: false,
            phones: {},

            profiles_by_hash: null,
        }),
        mounted() {
            let self = this;
            this.fetchProfilesByHash();
            this.profile = this.ensureDataConsistencyProfile(this.profile_model);
            this.last_saved_profile_stringify = JSON.stringify(this.profile.data);

            if (!this.profile.id) this.save();

            // При открытии профиля, если он существует в базе, перезапрашиваем его.
            if (this.profile.id) {
                this.loading = true;
                this.getProfile()
                    .then(function (response) {
                        self.profile = self.ensureDataConsistencyProfile(response.data);
                        self.last_saved_profile_stringify = JSON.stringify(self.profile.data);
                        self.loading = false;
                    })
            }

            // this.auto_save_interval = setInterval(function () {
            //     self.autoSave()
            //     .then(function () {
            //         self.autoRefresh();
            //     })
            // }, 5000);

            let init_socket = setInterval(function () {
                if (self.profile.id) {
                    clearInterval(init_socket);
                    self.initSocket();
                }
            }, 100)
        },
        beforeDestroy() {
            clearInterval(this.auto_save_interval);
            Echo.leave(`request.${this.profile.request_id}.profile.${this.profile.id}`);
        },
        watch: {
            'profile.data.ldu_phone'(val){if (val && this.validatePhone(this.preparePhone(val))) this.phones['ldu_phone'] = val},
            'profile.data.registration_phone'(val){if (val && this.validatePhone(this.preparePhone(val))) this.phones['registration_phone'] = val},
            'profile.data.residence_phone'(val){if (val && this.validatePhone(this.preparePhone(val))) this.phones['residence_phone'] = val},
            'profile.data.job_organization_phone'(val){if (val && this.validatePhone(this.preparePhone(val))) this.phones['job_organization_phone'] = val},
            'profile.data.job_boss_phone'(val){if (val && this.validatePhone(this.preparePhone(val))) this.phones['job_boss_phone'] = val},
            'profile.data.spouse_phone'(val){if (val && this.validatePhone(this.preparePhone(val))) this.phones['spouse_phone'] = val},
        },

        methods: {
            async onRemovedPhone(field) {
                let self = this;
                await this.sleep(100);
                this.prepareProfile();

                if (!this.profile.data[field] && this.phones[field]) {
                    Swal.fire({
                        title: 'Поле с телефоном было очищено. Вы хотите удалить телефон?',
                        text: "Подтвердите удаление телефона " + self.phones[field] + "!",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#d33',
                        cancelButtonColor: '#3085d6',
                        confirmButtonText: 'Да, удалить!',
                        cancelButtonText: 'Отмена'
                    }).then((result) => {
                        if (result.value) {
                            self.phones[field] = null;
                            self.profile.data[field] = null;
                        } else {
                            self.profile.data[field] = self.phones[field];
                        }
                        self.changeField(field);
                    });
                } else {
                    this.changeField(field)
                }
            },
            ensureDataConsistencyProfile(o) {
                let d = {
                    title: null,
                    car: null,
                    car_year: null,
                    car_cost: null,
                    credit_term: null,
                    credit_initial_payment: null,
                    kasko_in_credit: null,

                    last_name: null,
                    first_name: null,
                    middle_name: null,
                    changed_lastname: null,
                    birthdate: null,
                    birthplace: null,
                    photo_client: [],

                    passport_series: null,
                    passport_number: null,
                    passport_division_code: null,
                    passport_issue_date: null,
                    passport_issuing_authority: null,
                    passport_old: null,
                    passport_scans: [],

                    driving_license_isset: null,
                    driving_license_series:null,
                    driving_license_number:null,
                    driving_license_division_code:null,
                    driving_license_experience:null,
                    driving_license_issuing_authority:null,
                    driving_license_scans:null,

                    ldu_isset: null,
                    ldu_last_name: null,
                    ldu_first_name: null,
                    ldu_middle_name: null,
                    ldu_type_relationship: null,
                    ldu_birthdate: null,
                    ldu_birthplace: null,
                    ldu_phone: null,
                    ldu_passport_series: null,
                    ldu_passport_number: null,
                    ldu_passport_division_code: null,
                    ldu_passport_issue_date: null,
                    ldu_passport_issuing_authority: null,
                    ldu_passport_scans: [],
                    ldu_driving_license_series: null,
                    ldu_driving_license_number: null,
                    ldu_driving_license_division_code: null,
                    ldu_driving_license_experience: null,
                    ldu_driving_license_issuing_authority: null,
                    ldu_driving_license_scans: null,
                    ldu_registration_address: null,
                    ldu_registration_date: null,

                    registration_address: null,
                    registration_address_ownership: null,
                    registration_date: null,
                    registration_phone: null,
                    registration_and_residence_address_match: null,
                    residence_address: null,
                    residence_ownership: null,
                    residence_period: null,
                    residence_phone: null,

                    snils: null,
                    international_passport: null,
                    military_id: null,
                    inn: null,
                    other_documents_scans: [],

                    education: null,

                    job_isset: null,
                    job_organization_name: null,
                    job_organization_inn: null,
                    job_organization_phone: null,
                    job_organization_address_legal: null,
                    job_organization_address_real: null,
                    job_organization_business_field: null,
                    job_position: null,
                    job_experience: null,
                    job_general_experience: null,
                    job_boss_fullname: null,
                    job_boss_phone: null,

                    income_monthly_average: null,
                    income_additional: null,
                    income_additional_comment: null,
                    spouse_income_monthly_average: null,
                    spouse_income_additional: null,
                    spouse_income_additional_comment: null,
                    family_income_monthly_average: null,
                    family_income_additional: null,
                    family_income_additional_comment: null,

                    family_status: null,
                    spouse_last_name: null,
                    spouse_first_name: null,
                    spouse_middle_name: null,
                    spouse_birthplace: null,
                    spouse_birthdate: null,
                    spouse_phone: null,
                    spouse_job_organization_name: null,
                    spouse_job_position: null,

                    children_count: null,
                    children_dependent_count: null,

                    were_loans: null,
                    were_loans_comment: null,

                    current_loans_isset: null,
                    current_loans_bank_name: null,
                    current_loans_target: null,
                    current_loans_total_amount: null,
                    current_loans_monthly_payment: null,
                    current_loans_remaining_debt: null,





                    agreements_scans: [],

                };
                o.data = _.defaultsDeep(o.data, d);
                return o;
            },
            initSocket() {
                let self = this;
                Echo.private(`request.${this.profile.request_id}.profile.${this.profile.id}`)
                    .listen('.request_profile.updated_field', function (e) {
                        if (Echo.socketId() === e.socket_id) return;
                        self.profile.data[e.field_name] = e.value;
                        self.last_saved_profile_stringify = JSON.stringify(self.profile.data);
                    })
            },
            addContactPerson() {
                this.profile.data.contact_persons.push({id: Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)});
                this.changeField('contact_persons');
            },
            deleteContactPerson(id) {
                this.profile.data.contact_persons = _.filter(this.profile.data.contact_persons, function (item) {
                    return item.id !== id;
                });
                this.changeField('contact_persons');
                // this.save();
            },
            incrementChanged() {
                this.changed_count = this.changed_count + 1;
            },
            async sleep(ms) {
                return new Promise(resolve => setTimeout(resolve, ms));
            },
            enableFields(fields) {
                for (let f in fields) {
                    let field = fields[f];
                    let el = $('#profile_data_' + field);
                    if (el) el.removeAttr('disabled');
                }
            },
            disableFields(fields) {
                for (let f in fields) {
                    let field = fields[f];
                    let el = $('#profile_data_' + field);
                    if (el) el.attr('disabled', 'disabled');
                }
            },
            async changeField(field_name) {
                if (!this.$hasPermission('requests.profiles.edit')) return;
                await this.sleep(100);

                let self = this;
                let field;
                if (typeof field_name !== "object") {
                    field_name = [field_name];
                }
                this.disableFields(field_name);
                for (let f in field_name) {
                    field = field_name[f];
                    self.prepareProfile();
                    if (self.profile.data[field] !== JSON.parse(self.last_saved_profile_stringify)[field]) {
                        self.last_saved_profile_stringify = JSON.stringify(self.profile.data);
                        await self.updateField(field, self.profile.data[field]);
                    }
                }
                this.enableFields(field_name);
                this.$message.success({
                    message: 'Автосохранение',
                    duration: 1000,
                });
            },
            preparePhone (p) {
                return p.replace(/[^\+0-9]/g, '');
            },
            validatePhone (p) {
                return !!(p.slice(0,2) === '+7' && p.length === 12);
            },
            prepareProfile() {
                let self = this;
                let prepared_phone = "";
                if (this.profile.data.contact_persons) {
                    this.profile.data.contact_persons.map(function (contact) {
                        if (contact.phone) {
                            prepared_phone = self.preparePhone(contact.phone);
                            if (!self.validatePhone(prepared_phone)) contact.phone = null;
                        }
                        return contact;
                    })
                }

                if (this.profile.data.ldu_phone) {
                    if (!this.validatePhone(this.preparePhone(this.profile.data.ldu_phone))) this.profile.data.ldu_phone = null;
                }
                if (this.profile.data.registration_phone) {
                    if (!this.validatePhone(this.preparePhone(this.profile.data.registration_phone))) this.profile.data.registration_phone = null;
                }
                if (this.profile.data.residence_phone) {
                    if (!this.validatePhone(this.preparePhone(this.profile.data.residence_phone))) this.profile.data.residence_phone = null;
                }
                if (this.profile.data.job_organization_phone) {
                    if (!this.validatePhone(this.preparePhone(this.profile.data.job_organization_phone))) this.profile.data.job_organization_phone = null;
                }
                if (this.profile.data.job_boss_phone) {
                    if (!this.validatePhone(this.preparePhone(this.profile.data.job_boss_phone))) this.profile.data.job_boss_phone = null;
                }
                if (this.profile.data.spouse_phone) {
                    if (!this.validatePhone(this.preparePhone(this.profile.data.spouse_phone))) this.profile.data.spouse_phone = null;
                }
            },
            copyAddress() {
                this.profile.data.residence_address = this.profile.data.registration_address;
                this.profile.data.residence_ownership = this.profile.data.registration_address_ownership;
            },
            changeAddress() {
                if (this.profile.data.registration_and_residence_address_match) {
                    this.profile.data.residence_address = this.profile.data.registration_address;
                    this.profile.data.residence_ownership = this.profile.data.registration_address_ownership;
                }
            },


            // autoSave() {
            //     let self = this;
            //     let is_changed = JSON.stringify(this.profile.data) !== this.last_saved_profile_stringify;
            //     if (!is_changed && this.changed_count > 0) this.changed_count = 0;
            //
            //     if (this.$hasPermission('requests.profiles.edit') && this.changed_count > 0 && is_changed) {
            //         return this.save()
            //             .then(function (response) {
            //                 self.$message.success({
            //                     message: 'Автосохранение',
            //                     duration: 500,
            //                 });
            //                 self.changed_count = 0;
            //             });
            //     }
            //     return new Promise(function(resolve, reject) {resolve();})
            // },
            // autoRefresh() {
            //     let self = this;
            //     if (this.$hasPermission('requests.profiles.show') && JSON.stringify(this.profile.data) === this.last_saved_profile_stringify) {
            //         self.refreshProfile();
            //     }
            // },
            clickSave() {
                let self = this;
                if (!this.$hasPermission('requests.profiles.edit')) return;
                this.save()
                    .then(function (response) {
                        self.$message.success({
                            message: 'Сохранено',
                            duration: 1000,
                        });
                    });
            },
            save() {
                let self = this;
                let need_saving = JSON.stringify(this.profile.data);
                this.prepareProfile();
                return (!this.profile.id ? this.store() : this.update())
                    .then(function (response) {
                        self.last_saved_profile_stringify = need_saving;

                        self.profile.id = response.data.id;
                        return response;
                    });
            },
            store() {
                return axios.post('/api/request_profiles', this.profile)
            },
            update() {
                return axios.put('/api/request_profiles/' + this.profile.id, this.profile)
            },
            async updateField(field_name, value) {
                return axios.put('/api/request_profiles/' + this.profile.id + '/update_field', {
                    field_name: field_name,
                    value: value,
                    socket_id: Echo.socketId(),
                })
            },

            // refreshProfile() {
            //     let self = this;
            //     return this.getProfile().then(function (response) {
            //         if (JSON.stringify(self.profile.data) === self.last_saved_profile_stringify) {
            //             self.profile = response.data;
            //             self.last_saved_profile_stringify = JSON.stringify(response.data.data);
            //         }
            //     });
            // },
            getProfile() {
                return axios.get('/api/request_profiles/' + this.profile.id);
            },
            fetchProfilesByHash() {
                let self = this;
                axios.get('/api/requests/' + this.profile_model.request_id + '/profiles', {params: {byHash: 1}})
                    .then(response => {
                        self.profiles_by_hash = response.data
                    });
            },
            copy(data) {
                this.profile.data = data;
                this.save();
            },
            onDocOCRRecognized(fields) {
                for (let key in fields) {
                    if (!Object.prototype.hasOwnProperty.call(fields, key)) {
                        continue;
                    }
                    this.profile.data[key] = fields[key];
                }
                this.save();
            }
        },
    }
</script>

<style lang="scss" scoped>
    .content-inputs {
        .vs-input-parent {
            margin: 10px;
        }
    }
    /*.content-inputs .vs-input-parent{*/
    /*    margin: 10px;*/
    /*}*/
</style>
